'use client';
const UNARY_BREAKPOINT_FUNCTIONS = [
    'up',
    'down',
    'not',
    'only'
];
const parseBasicQuery = (query)=>{
    const [size, fn] = query.split('.');
    return {
        isValid: size && fn && UNARY_BREAKPOINT_FUNCTIONS.includes(fn),
        size,
        fn
    };
};

export { parseBasicQuery };
//# sourceMappingURL=parseBasicQuery.js.map
